let host = document.location.host;
let apiUrl = process.env.REACT_APP_API_URL

const environment = {
  api: apiUrl,
  frontendUrl: process.env.REACT_APP_FRONTEND_URL,
  map_api_key: process.env.REACT_APP_GOOGLE_API_KEY,
  recipientRole: process.env.REACT_APP_RECIPIENT_ROLE,
  userRole: process.env.REACT_APP_USER_ROLE,
};

export default environment;
